// White-label branding helper: the partner logo.
//
// Normal brands use the LearnZapp logo and the per-exam THEME_DARK/THEME_LIGHT colors (from the
// brand's config.json bundleApps, applied via getColorTheme). White-label brands additionally
// ship partner logos (client_logo_light/dark, served from /assets/images by switch-app).
import { IMAGES } from "../assets";
import { IS_WHITE_LABEL } from "../utils/brandFlags";

// Partner logo for white-label brands; LearnZapp logo otherwise.
export async function getAppLogo(currentTheme) {
  if (!IS_WHITE_LABEL) return IMAGES.logo;
  return currentTheme === "dark" ? IMAGES.client_logo_dark : IMAGES.client_logo_light;
}
